import axios from "axios";
import { Base_URL } from "../../Client/apiURL";
import { normalizeBankTransferApiStatus } from "./bankTransferUtils";

export const fetchBankTransferStatus = async () => {
  const response = await axios.get(
    `${Base_URL}/app/users/user-transactions/bank-transfer-status`,
    { withCredentials: true }
  );
  return normalizeBankTransferApiStatus(response.data);
};
